import { __awaiter, __decorate, __extends, __generator, __metadata } from "tslib";
import { Aggregate } from '../../base/ddd-types/aggregate';
import { dataFieldNamingHandler, exceptionHandler, fireEvent, paramsFieldNamingHandler, parseObjectData, parseResBody, setDataHandleFunctionName, } from '../../base/decorators';
import { NotifyScopeRepository } from '../repository/notify-scope-repository';
import { NotifyInfo } from '../value-object/notify-info';
import { Emitter } from '@tencent/ark-utils/lib/event';
// notifyInfo信息更新事件名
var NOTIFY_INFO_DID_UPDATE_EVENT_NAME = 'mOnNotifyInfoDidUpdated';
// notifyInfo信息属性Key值
var NOTIFY_INFO_PREPOTRY_KEY = 'notifyInfo';
var setNotifyTypeWithParams = 'setNotifyTypeWithParams';
var NotifyScopeAggregate = /** @class */ (function (_super) {
    __extends(NotifyScopeAggregate, _super);
    function NotifyScopeAggregate(id) {
        var _this = _super.call(this, id) || this;
        _this.mOnNotifyInfoDidUpdated = new Emitter();
        // 数据请求实体
        _this.notifyScopeRepository = new NotifyScopeRepository();
        _this.onNotifyInfoDidUpdated = _this.mOnNotifyInfoDidUpdated.event;
        return _this;
    }
    /**
     * cgi服务
     */
    NotifyScopeAggregate.prototype.getNotifyType = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.notifyScopeRepository.getNotifyType(params)];
            });
        });
    };
    NotifyScopeAggregate.prototype.setNotifyType = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.notifyScopeRepository.setNotifyType(params)];
            });
        });
    };
    NotifyScopeAggregate.prototype.editnotify = function (params) {
        return this.notifyScopeRepository.editnotify(params);
    };
    NotifyScopeAggregate.prototype.setNotifyTypeWithParams = function (params) {
        if (!params || params.length < 1) {
            return;
        }
        this.notifyInfo = new NotifyInfo({
            notifyType: params[0].notifyType,
        });
    };
    __decorate([
        fireEvent(NOTIFY_INFO_DID_UPDATE_EVENT_NAME, NOTIFY_INFO_PREPOTRY_KEY),
        parseObjectData(NotifyInfo.prototype.constructor, NOTIFY_INFO_PREPOTRY_KEY),
        dataFieldNamingHandler(),
        parseResBody(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], NotifyScopeAggregate.prototype, "getNotifyType", null);
    __decorate([
        fireEvent(NOTIFY_INFO_DID_UPDATE_EVENT_NAME, NOTIFY_INFO_PREPOTRY_KEY),
        setDataHandleFunctionName(setNotifyTypeWithParams),
        parseResBody(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], NotifyScopeAggregate.prototype, "setNotifyType", null);
    __decorate([
        dataFieldNamingHandler(),
        parseResBody(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], NotifyScopeAggregate.prototype, "editnotify", null);
    return NotifyScopeAggregate;
}(Aggregate));
export { NotifyScopeAggregate };
